import Sidebar from "../components/Sidebar";

const Settings = () => {
  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <main className="flex-1 p-8 bg-gray-50">
        <h1 className="text-3xl font-bold mb-6">Settings</h1>
        <p className="text-gray-600">
          Manage your restaurant info, payout details, and platform integrations
          here.
        </p>
      </main>
    </div>
  );
};

export default Settings;
